'use client'

import React from 'react'
import { BTC_ID, type PoolToken } from '../lib/amm'

/// The shared asset icon. Token selection moved into the terminal search and
/// asset rail; keeping only this primitive avoids shipping the retired picker.
export function TokenIcon({ token, size = 20 }: { token: PoolToken; size?: number }) {
	const [failed, setFailed] = React.useState(false)
	// Some collection rows store raw inline SVG markup instead of a URL.
	const src =
		token.icon && token.icon.trimStart().startsWith('<svg')
			? `data:image/svg+xml;utf8,${encodeURIComponent(token.icon)}`
			: token.icon
	if (!src || failed) {
		return (
			<span
				// Decorative: the token's name is already the adjacent text, so
				// announcing the initials made rows read "TO TORTILLA 2:62083".
				aria-hidden="true"
				className="inline-flex shrink-0 items-center justify-center rounded-full bg-muted text-[9px] font-semibold text-muted-foreground"
				style={{ width: size, height: size }}
			>
				{token.id === BTC_ID ? '₿' : (token.name || token.id).slice(0, 2).toUpperCase()}
			</span>
		)
	}
	return (
		<img
			src={src}
			alt=""
			width={size}
			height={size}
			// The discovery feed draws eighty-eight of these at once. Lazy +
			// async keeps the ones below the fold off the first paint's critical
			// path and their decode off the main thread while it scrolls.
			loading="lazy"
			decoding="async"
			// bg-muted: a lazy icon paints as a surface-colored disc until its
			// bytes decode, instead of a blank hole in the row.
			className="shrink-0 rounded-full bg-muted object-cover"
			onError={() => setFailed(true)}
		/>
	)
}
